import { Button } from "@sphinx/design-system/button";
import { Link } from "react-router";
import { cn } from "@/lib/utils";
import { routePaths } from "@/lib/app-navigation";

interface SphinxFreeModelsPromptProps {
  onSignUp: () => void;
  className?: string;
}

export function SphinxFreeModelsPrompt({
  onSignUp,
  className,
}: SphinxFreeModelsPromptProps) {
  return (
    <div
      className={cn(
        "max-w-2xl mx-auto space-y-4 text-center flex flex-col items-center justify-center",
        className,
      )}
    >
      <div className="space-y-1">
        <h2 className="text-2xl font-semibold tracking-tight">
          Test your MCP server with Claude and GPT models
        </h2>
      </div>

      <div className="flex justify-center items-center gap-4 py-3">
        <div className="flex items-center justify-center">
          <img
            src="/claude_logo.png"
            alt="Claude"
            className="w-8 h-8 object-contain opacity-70 hover:opacity-100 transition-opacity"
          />
        </div>
        <div className="flex items-center justify-center">
          <img
            src="/openai_logo.png"
            alt="OpenAI"
            className="w-8 h-8 object-contain opacity-70 hover:opacity-100 transition-opacity"
          />
        </div>
      </div>

      <div className="space-y-2 text-center">
        <Button
          onClick={onSignUp}
          size="lg"
          className="hover:opacity-90 cursor-pointer font-semibold px-8 py-6 text-base"
        >
          Get started
        </Button>
        <p className="text-xs text-muted-foreground">
          or bring your own API key in{" "}
          <Link
            to={routePaths.settings}
            className="underline hover:text-foreground transition-colors"
          >
            settings
          </Link>
        </p>
      </div>
    </div>
  );
}
